import React from "react";
import { MapPin } from "../ui/icons";
import { GeocodingFeature } from "../../global/types/geocoding";

interface GeocodingSuggestionsProps {
  results: GeocodingFeature[];
  onSelect: (feature: GeocodingFeature) => void;
  maxResults?: number;
}

export function GeocodingSuggestions({
  results,
  onSelect,
  maxResults = 2,
}: GeocodingSuggestionsProps) {
  const displayResults = results.slice(0, maxResults);

  if (displayResults.length === 0) {
    return null;
  }

  const getFeatureDisplayName = (feature: GeocodingFeature): string => {
    return feature.name || "Localização";
  };

  return (
    <div className="flex-1 flex items-center gap-2 pr-3 overflow-x-auto overflow-y-hidden [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      {displayResults.map((feature, index) => (
        <button
          key={`${feature.properties.cd_mun || feature.id || index}`}
          onClick={() => onSelect(feature)}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-light/10 hover:bg-green-light/20 text-green-dark border border-green-light/30 rounded-md transition-colors text-sm whitespace-nowrap flex-shrink-0"
        >
          <MapPin className="h-4 w-4 text-green-light" />
          <span className="font-medium">{getFeatureDisplayName(feature)}</span>
        </button>
      ))}
    </div>
  );
}
